module.exports = __webpack_public_path__ + "img/特徴-01.ff8b130d.png";